<template>

  <div class="upload-btn-wrapper " style="cursor: pointer">
    <CButton size="sm" color="primary" shape="pill" variant="outline"  >
      <CIcon name="cil-cloud-upload"/>
    </CButton>
    <input type="file" @change="onChange" style="width: 35px; height: 35px;" />
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import Vue from 'vue'
import {mapGetters} from 'vuex'
export default {
  name: 'MUploadFile',
  props: {
    caption: {
      type: String,
      default: ' Campus '
    },
    item : {
      type: Object
    }

  },

  data: function () {
    return {
    }
  },

  mounted () {
  },

  created () {

  },
  beforeDestroy () {

  },

  methods: {
    onChange(event) {
      // this.$props.item.students = [ { "infomation": { "firstName": "Saksith", "lastName": "" }, "code": "1", "avata": "2", "type": "", "value": {} } ]
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
      //
        for(var i=0; i<workbook.SheetNames.length; i++){
          var objsArr = [];
          var sheetName = workbook.SheetNames[i];
          var worksheet = workbook.Sheets[sheetName];
          var data = XLSX.utils.sheet_to_json(worksheet,{ header: 1 })
          for(var j=1; j<data.length; j++){
            var objs = {};
            objs.infomation = { "firstName": "Saksith", "lastName": "" }
            objs.code = data[j][1]
            // objs.prefix = data[j][1]
            // objs.name = data[j][2]
            // objs.surname = data[j][3]
            // objs.section = data[j][4]
            // objs.score = data[j][5]
            objsArr.push(objs)


            var isObject = this.$props.item.students.filter(item => { return (item.code == objs.code)})
            if(isObject.length > 0){

            }else{
              this.$props.item.students.push(objs)
            }

          }
          // this.rubrics.goal6[i].student = objsArr;
          // this.rubrics.goal6.push({})
          // this.rubrics.goal6.pop()
          // this.$store.commit("course/setRubrics",  this.rubrics)
          // this.rubricReprot = this.$store.getters['course/objRubrics']
        }
      };
    },

  },

  computed:{
    ...mapGetters({
    })
  },

  watch: {
  }

}
</script>
<style>
.upload-btn-wrapper {
  position: relative;
  /*overflow: hidden;*/
  display: inline-block;
}
.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
